import React from 'react';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { Box, useTheme } from '@mui/material';
import { Theme } from '@shape-ds/components';

const LinkComponent = ({ link }: { link?: string }) => {
  const theme = useTheme<Theme>();
  return (
    <Box component={link ? 'a' : 'span'} href={link ?? ''} target="_blank" rel="noreferrer">
      <AttachFileOutlinedIcon
        sx={{
          width: '16px',
          height: '16px',
          fill: link ? theme.tokens.colors.blue[2] : '#999',
        }}
      />
    </Box>
  );
};

export default LinkComponent;
